import React, { memo } from 'react';
import LazyImage from '../../CustomLibraries/LazyImage';
import { BsPlusLg, FiShare2, RiUserFollowFill } from '../../icons';
import './css/_channelCardV2.scss';

function ChannelCardV2(props) {
  return (
    <div className="w-100 channelCardV2Box bg-white shadow rounded-3 position-relative overflow-hidden">
      <div className="channelCardCoverImg position-relative">
        <LazyImage
          src="https://st2.depositphotos.com/3889193/12453/i/950/depositphotos_124530450-stock-photo-a-professional-medical-team-posing.jpg"
          alt="Medwiki img"
          className="object-fit-cover w-100 h-100 float-start position-absolute top-0 start-0"
          extraClass="w-100 h-100 position-relative overflow-hidden"
        />
        <div className="overlay bg-black bg-opacity-50"></div>
      </div>
      <div className="channelCardBtm text-start px-3 px-md-4 position-relative">
        <div className="channelCardBtmIn bg-white rounded-3 d-flex justify-content-between p-3 p-md-4">
          <div className="channelLogo rounded-circle bg-white border-2 border-light p-1 p-md-2 mr-3 mr-md-4">
            <LazyImage
              src="https://www.clirnet.com/themes/front/images/logo.png"
              alt="Logo"
              className="mw-100 mh-100 w-auto h-auto"
              extraClass="w-100 h-100 position-relative overflow-hidden d-flex justify-content-center align-items-center"
              logo
            />
          </div>
          <div className="channelDetails flex-1">
            <h4 className="fs-16 fw-medium text-black line-clamp-2 mb-2">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora nam at consectetur
              tempore exercitationem quas dicta illo error labore! Soluta at possimus est accusamus
              dignissimos autem asperiores unde nobis quidem!
            </h4>
            <h6 className="fs-4 fw-normal text-dark line-clamp-2 mb-3">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Error, ut obcaecati. Impedit
              porro et illo repellat velit consequatur aspernatur exercitationem quia, sit,
              inventore voluptatum iure, praesentium reprehenderit. Commodi, expedita similique!
            </h6>
            <div className="channelBtns d-flex flex-wrap gap-3">
              <a
                href="javascript:void(0)"
                className="fs-16 fw-medium btn btn-primary rounded-3 py-3 px-4 me-3"
              >
                Follow
                <BsPlusLg customClass={'fs-16 ms-3'} />
              </a>
              <a
                href="javascript:void(0)"
                className="fs-16 fw-medium btn btn-secondary rounded-3 py-3 px-4"
              >
                <FiShare2 customClass={'fs-16 me-3'} />
                Share
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default memo(ChannelCardV2);
